"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackEventEpics = void 0;

var _operators = require("rxjs/operators");

var _utils = require("@alycecom/utils");

var _trackEvent = require("./trackEvent.actions");

var setIdentityEpic = function setIdentityEpic(action$, state$, _ref) {
  var analyticService = _ref.analyticService;
  return action$.pipe((0, _utils.ofType)(_trackEvent.setIdentity), (0, _operators.mergeMap)(function (_ref2) {
    var _ref2$payload = _ref2.payload,
        id = _ref2$payload.id,
        traits = _ref2$payload.traits,
        options = _ref2$payload.options;
    analyticService.setIdentity(id, traits, options);
    return [];
  }));
};

var addPropertiesEpic = function addPropertiesEpic(action$, state$, _ref3) {
  var analyticService = _ref3.analyticService;
  return action$.pipe((0, _utils.ofType)(_trackEvent.addUserProperties), (0, _operators.mergeMap)(function (_ref4) {
    var payload = _ref4.payload;
    analyticService.addUserProperties(payload);
    return [];
  }));
};

var trackEventEpic = function trackEventEpic(action$, state$, _ref5) {
  var analyticService = _ref5.analyticService;
  return action$.pipe((0, _utils.ofType)(_trackEvent.trackEvent), (0, _operators.mergeMap)(function (_ref6) {
    var payload = _ref6.payload;
    analyticService.trackEvent(payload);
    return [];
  }));
};

var trackEventEpics = [setIdentityEpic, addPropertiesEpic, trackEventEpic];
exports.trackEventEpics = trackEventEpics;